<!--全局变量-->
<script>
const WEB_SITE = 'http://zhiyanxueshe.com/api/'
const WEB_URL = 'http://zhiyanxueshe.com/'
const QINIU_URL = ''
const WEB_NAME = '环球吉星'
const APPID = ''
export default {
    WEB_SITE,
    WEB_NAME,
    WEB_URL,
    QINIU_URL,
    APPID,
}
</script>
